import { createFileRoute } from '@tanstack/react-router';

import { Posts } from '#modules/finder/features/posts/components/Posts';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/posts/_posts/'
)({
  component: Posts,
  ssr: false,
});
